var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"chartContainer",staticClass:"pa-3",staticStyle:{"width":"96%","height":"90%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }